import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ButtonWithAction,
  ButtonWithLink,
  SidebarSingleContent,
  Box,
  Cluster,
  constants,
  Center,
  DisplayBox,
  Title,
  Spinner,
} from '@thecb/components';
import AlertBar from '../../components/alert-bar';
import CartSidebar from '../../components/cart-sidebar';
import { InputByCriteria } from '../../components/form-blocks';
import { useSelector } from 'react-redux';
import SharedAlertBar from '../../components/alert-bar/SharedAlertBar';

const Header = ({ alertBar, alertBarActions }) => {
  const { alerts: sharedAlerts } = useSelector((state) => state.shared);
  return (
    <Box width="100%" padding="16px 0">
      <Center maxWidth="85.714rem">
        {alertBar.alerts.length > 0 && (
          <Box padding="16px 0">
            <AlertBar {...alertBar} {...alertBarActions} />
          </Box>
        )}
        {sharedAlerts.length > 0 && (
          <Box padding="16px 0">
            <SharedAlertBar />
          </Box>
        )}
        <Title
          color={constants.colors.CHARADE_GREY}
          weight={constants.fontWeights.FONT_WEIGHT_BOLD}
        >
          Search
        </Title>
      </Center>
    </Box>
  );
};

const Search = ({ fetchSearchById, sendSearchRequest, alertBars, actions }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isLoading: isLoadingSearch } = useSelector((state) => state.search);
  const {
    error: hasErrors,
    currentProduct: {
      status,
      fetching: isLoadingProduct,
      form_data: searchCriteria,
      product_data,
    },
  } = useSelector((state) => state.products);
  const canRenderForm =
    !isLoadingProduct &&
    !hasErrors &&
    status === 'success' &&
    !!searchCriteria &&
    !!product_data;

  useEffect(() => {
    fetchSearchById(id);
  }, []);

  const submitSearch = (formData) => {
    sendSearchRequest({
      ...formData,
      id,
      navigate,
    });
  };

  const formActions = (
    <Box padding="1rem 0 0 0">
      <Cluster justify="flex-end" align="center">
        <ButtonWithLink
          text="Cancel"
          type="button"
          url={`/pos/products`}
          isLoading={false}
          variant="secondary"
          dataQa="Cancel"
          textExtraStyles="font-size: 1rem;"
        />
        <ButtonWithAction
          type="submit"
          text="Submit"
          variant="primary"
          dataQa="Submit"
          disabled={isLoadingSearch}
          isLoading={isLoadingSearch}
          textExtraStyles="font-size: 1rem;"
        />
      </Cluster>
    </Box>
  );

  const content = (
    <DisplayBox padding="16px 0">
      <>
        {isLoadingProduct && <Spinner size="100" />}
        {canRenderForm && (
          <InputByCriteria
            submitForm={submitSearch}
            criteria={searchCriteria}
            criteriaGroupName={product_data?.name}
            formActions={formActions}
          />
        )}
      </>
    </DisplayBox>
  );

  return (
    <SidebarSingleContent
      header={
        <Header
          key="SearchHeader"
          alertBar={alertBars.searchAlertBars}
          alertBarActions={actions.alertBars.searchAlertBars}
        />
      }
      mainContent={content}
      sidebarContent={<CartSidebar />}
      sidebarTargetWidth="27.429rem"
      sidebarWrapperMaxWidth="85.714rem"
      sidebarOnRight={true}
      childGap="0.5rem"
    />
  );
};

export default Search;
